export const css = {
    root: '_1fcUAtER',
    buttonGroup: '_3_dO1-xq',
    buttonWrapper: '_3ipl0BeR',
    title: '_1kei7vRe',
    active: '_46pTVV4f',
    arrow: 'V1_Z5-bt',
    ' _key': 'explore-view/you-are-here'
};
export default css;
